// extracted by mini-css-extract-plugin
module.exports = {"componentsWhiteSpace":"styles_componentsWhiteSpace__25E8E"};